<template>
  <div>
    <v-btn
      x-small
      fab
      color="pink"
      class="float-right mt-4"
      dark
      @click="openAddNoteDialog()"
      ><v-icon>mdi-plus</v-icon></v-btn
    >
    <v-layout row wrap>
      <v-flex sm4 xs12 v-for="(note, i) in notes" :key="i + Math.random()"
        ><StickyNotes :note="note" @note-deleted="refreshNotes"></StickyNotes
      ></v-flex>
    </v-layout>
    <GlobalDialogSlot
      :dialog="dialog"
      :title="'Add Note to ' + getCompanyLabels.matter"
      @close-dialog="closeDialog"
    >
      <v-select
        class="mx-6"
        :items="billables"
        label="Billable Activity"
        v-model="selectedBillable"
      ></v-select>
      <DatePickerWithMenu
            label="Select Billing Date"
            @date-selected="setBillingDate"
          ></DatePickerWithMenu>
      <v-text-field
        v-if="
          (selectedBillable &&
            selectedBillable.itemType == 'billable' &&
            selectedBillable.qtyIncrementID != 1) ||
          (selectedBillable && selectedBillable.itemType == 'service') ||
          (selectedBillable && selectedBillable.itemType == 'product') ||
          (selectedBillable && selectedBillable.itemType != 'transport')
        "
        class="mx-6"
        v-model="units"
        :label="
          selectedBillable.qtyIncrementID &&
          (selectedBillable.qtyIncrementID == 2 ||
            selectedBillable.qtyIncrementID == 7)
            ? 'Minutes'
            : selectedBillable.qtyIncrementID &&
              selectedBillable.qtyIncrementID == 3
            ? 'Copies'
            : selectedBillable.qtyIncrementID &&
              selectedBillable.qtyIncrementID == 4
            ? 'Folios'
            : selectedBillable.qtyIncrementID &&
              selectedBillable.qtyIncrementID == 5
            ? 'Number of Calls'
            : selectedBillable.qtyIncrementID &&
              selectedBillable.qtyIncrementID == 6
            ? 'Number of Attendances'
            : selectedBillable.qtyIncrementID &&
              selectedBillable.qtyIncrementID == 8
            ? 'Number of Persons'
            : selectedBillable.qtyIncrementID &&
              selectedBillable.qtyIncrementID == 9
            ? 'Hours'
            : selectedBillable.qtyIncrementID &&
              selectedBillable.qtyIncrementID == 10
            ? 'Number of Pages'
            : selectedBillable.itemType &&
              selectedBillable.itemType == 'service'
            ? 'Hours'
            : selectedBillable.itemType &&
              selectedBillable.itemType == 'product'
            ? 'Quantity'
            : selectedBillable.itemType &&
              selectedBillable.itemType == 'transport'
            ? 'Kilometers'
            : 'Flat Fee [Nothing is required here]'
        "
      ></v-text-field>
      <v-textarea
        clear-icon
        class="px-6 py-4"
        name="input-7-1"
        label="Description"
        v-model="newNoteContent"
        hint="Type Your Note Here"
      ></v-textarea>
      <v-btn
        class="mb-3 ml-4"
        color="primary"
        dark
        rounded
        @click="saveNewNote()"
        ><v-icon left>mdi-content-save</v-icon> Save Note</v-btn
      ></GlobalDialogSlot
    >
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import StickyNotes from "@/components/myLibrary/StickyNote.vue";
import GlobalDialogSlot from "@/components/myLibrary/GlobalDialogSlot.vue";
import DatePickerWithMenu from "@/components/myLibrary/DatePickerWithMenu.vue";

export default {
  props: ["selectedCase"],
  watch: {
    selectedCase() {
      this.getAllNotes();
    },
  },
  components: { StickyNotes, GlobalDialogSlot,DatePickerWithMenu },
  computed: {
    getCompanyLabels() {
      return this.$store.getters.getCompanyLabels;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
  },
  mounted() {
    this.getAllNotes();
  },
  data: () => ({
    dialog: false,
    notes: [],
    billables: [],
    newNoteContent: null,
    selectedBillable: null,
    units: null,
    billingDate: new Date().toISOString().substr(0, 10)
  }),
  methods: {
    setBillingDate(billingDate) {
      this.billingDate = billingDate;
    },
    getAllNotes() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/get-all-notes-for-selected-matter",
          {
            caseID: this.selectedCase.id,
            courtTypeID: this.selectedCase.court_type_id,
            scaleID: this.selectedCase.scale_id,
          },
          this.getAccessToken
        )
        .then((data) => {
          this.billables = [];
          this.notes = data.notes;

          if (data.services.length > 0) {
            data.services.forEach((service) => {
              this.billables.push({
                text:
                  service.name + " | " + this.getCurrency + service.serviceFee,
                value: {
                  itemID: service.id,
                  description: service.name,
                  itemType: service.item_type,
                  amount: service.serviceFee,
                },
              });
            });
          }

          if (data.products.length > 0) {
            data.products.forEach((product) => {
              this.billables.push({
                text:
                  product.name + " | " + this.getCurrency + product.unitPrice,
                value: {
                  itemID: product.id,
                  description: product.name,
                  itemType: product.item_type,
                  amount: product.unitPrice,
                },
              });
            });
          }

          if (data.billables.length > 0) {
            data.billables.forEach((billable) => {
              this.billables.push({
                text:
                  billable.name +
                  " | " +
                  this.getCurrency +
                  billable.cost_per_hour +" "+ (billable.increments ? billable.increments.name :''),
                value: {
                  itemID: billable.id,
                  description: billable.name,
                  itemType: billable.item_type,
                  amount: billable.cost_per_hour,
                  qtyIncrementID: billable.qty_increment_id,
                },
              });
            });
          }

          if (data.transports.length > 0) {
            data.transports.forEach((transport) => {
              this.billables.push({
                text:
                  transport.name +
                  " | " +
                  this.getCurrency +
                  transport.transportationFee,
                value: {
                  itemID: transport.id,
                  description: transport.name,
                  itemType: transport.item_type,
                  amount: transport.transportationFee,
                },
              });
            });
          }

          this.$store.commit("setLoader", false);
        });
    },
    refreshNotes(notes) {
      this.notes = notes;
    },
    saveNewNote() {
      this.$store.commit("setLoader", true);
      let total = 0;
      let units = this.units ? Number(this.units) : 1;

      if (
        this.selectedBillable.qtyIncrementID &&
        this.selectedBillable.qtyIncrementID == 2
      ) {
        units = this.units ? Number(this.units) : 15;
        units = (units / 15).toFixed(2);
      } else if (
        this.selectedBillable.qtyIncrementID &&
        this.selectedBillable.qtyIncrementID == 7
      ) {
        units = this.units ? Number(this.units) : 5;
        units = (units / 5).toFixed(2);
      }

      if (this.selectedBillable && this.selectedBillable.amount) {
        total = (Number(units) * Number(this.selectedBillable.amount)).toFixed(
          2
        );
      }

      axios
        .postDataWithToken(
          "/auth/save-note",
          {
            description: this.newNoteContent,
            caseID: this.selectedCase.id,
            clientRef: this.selectedCase.client.client_reference,
            billableActivity: this.selectedBillable,
            units,
            total,
            billingDate:this.billingDate

          },
          this.getAccessToken
        )
        .then((notes) => {
          this.$emit("refresh-needed");
          this.getAllNotes();
          this.closeDialog();
        });
    },
    openAddNoteDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      this.newNoteContent = null;
    },
  },
};
</script>

<style></style>
